export default "/assets/ffbb0b541a61e02c.svg"